import { PayloadAction } from '../../../../../store.model';
import { syncTranscriptIsOpen } from '../function/sync-transcript-is-open.function';
import { ActionType } from '../transcript-summary.action';
import { TranscriptSummaryState } from '../transcript-summary.state';

import { ToggleCategoryTranscript } from './toggle-category-transcript.action';

export function toggleCategoryTranscriptReducer(
    state: TranscriptSummaryState,
    action: PayloadAction<ActionType, ToggleCategoryTranscript>,
): TranscriptSummaryState {
    const nextCats = syncTranscriptIsOpen(
        state.transcriptCategories,
        action.payload.transcriptId,
        action.payload.isOpen,
        action.payload.expandParent,
    );
    const nextFilteredCats = syncTranscriptIsOpen(
        state.filteredTranscriptCategories,
        action.payload.transcriptId,
        action.payload.isOpen,
        action.payload.expandParent,
    );

    return {
        ...state,
        transcriptCategories: nextCats,
        filteredTranscriptCategories: nextFilteredCats,
    };
}
